import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

/**
 * Prevents non-"Commerciale" users from accessing the route.
 * Redirects to /contracts if they try to access a restricted route.
 */
export const onlyCommercialeGuard: CanActivateFn = () => {
  const router = inject(Router);
  const isCommerciale = sessionStorage.getItem('commerciale') === 'true';

  if (!isCommerciale) {
    router.navigate(['/contracts']);
    return false;
  }

  return true;
};
